// Produto INATIVO nos campos de busca (pedido dele, 28/10/2026).
//
// A busca devolve os inativos no FIM da lista (`com_inativos=1` no GET /api/produtos) e a escolha
// e' recusada com a frase dele. Escondido, o inativo se lia como "nao cadastrado" — e a busca
// mostrava no lugar quem tinha o numero perdido na referencia (1421 trazia o 0240, ref. 071421).
// Impedir a escolha e esconder a opcao nao sao a mesma coisa ([DA-468]).
//
// Peca unica: a frase, o teste e o selo moram AQUI, e cada campo de busca so os chama.

import type { CSSProperties } from 'react';

export const MSG_PRODUTO_INATIVO = 'Para usar o Produto, primeiro altere seu status para Ativo';

// `status` ausente = a rota nao mandou: nao acusa (quem nao provou o estado nao afirma).
export function produtoInativo(p: { status?: string | null } | null | undefined): boolean {
  return !!p && p.status != null && p.status !== 'ativo';
}

// Selo da linha na lista de resultados. Par fixo cinza + preto (o mesmo do "indisponivel no site"
// do Monitor de Precos): nao e' alarme, e' estado.
export function SeloInativo({ style }: { style?: CSSProperties }) {
  return (
    <span
      style={{
        background: '#e5e7eb', color: '#000', border: '1px solid #6b7280', borderRadius: 3,
        padding: '0 5px', fontSize: 10, fontWeight: 700, marginRight: 6, whiteSpace: 'nowrap',
        ...style,
      }}
      title={MSG_PRODUTO_INATIVO}
    >
      INATIVO
    </span>
  );
}
